import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Icon } from "../../Component";

const PeriodFilter = ({ period, onPeriodChange }) => {
  const periods = [
    { value: "7d", label: "Last 7 days" },
    { value: "30d", label: "Last 30 days" },
    { value: "90d", label: "Last 90 days" },
    { value: "all", label: "All" },
  ];

  const currentPeriod = periods.find(p => p.value === period) || periods[1];

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
        <Icon name="calendar"></Icon>
        <span className="ms-1 d-none d-sm-inline">{currentPeriod.label}</span>
      </DropdownToggle>
      <DropdownMenu right>
        <ul className="link-list-opt no-bdr">
          {periods.map((p) => (
            <li key={p.value} className={period === p.value ? "active" : ""}>
              <DropdownItem
                tag="a"
                href="#period"
                onClick={(e) => {
                  e.preventDefault();
                  onPeriodChange(p.value);
                }}
              >
                <span>{p.label}</span>
              </DropdownItem>
            </li>
          ))}
        </ul>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default PeriodFilter;






